// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1qFGm","paramInput":"JobSimulator_paramInput__1Wp_c","input":"JobSimulator_input__wW1dr"};